import $ from 'jquery';

const $page = $('.page');
const $body = $('.page__body');
const $headerBottom = $('.header__bottom-wrapper');
let pageIsTop = true;

$(function () {
    pageScrolled(true);
    $body.on('scroll', pageScrolled);
});

const pageScrolled = (force = false) => {
    if ($body.scrollTop() > 0) {
        pageScrolledHandler(force);
    } else {
        pageTopHandler(force);
    }
};

const pageScrolledHandler = (force = false) => {
    if (pageIsTop === true || force === true) {
        pageIsTop = false;
        $page.addClass('page--scrolled');
        $headerBottom.stop().slideUp(300);
    }
};

const pageTopHandler = (force = false) => {
    if (pageIsTop === false || force === true) {
        pageIsTop = true;
        $page.removeClass('page--scrolled');
        $headerBottom.stop().slideDown(
            {
                start: function () {
                    $(this).css({
                        display: 'flex',
                    });
                },
            },
            300
        );
    }
};
